import React from 'react';
import { Box } from '@mui/material';
import SirenAnimation from '../../../Assets/animations/Siren.json';
import Lottie from 'lottie-react';
import { useAppNavigate } from '../../../Hooks/back/useAppNavigate';
import Icon from '../../../Assets/Icon/CustomIcon';
import { Button } from '../../../Components/MUIs';
import PerButton from '../../Permit/ui/PerButton';
import WorkStopDetailBottomSheet from '../ui/WorkStopDetailBottomSheet';
import { showSnackbar } from '../../../Reducer/SnackbarReducer';
import { useDispatch, useSelector } from 'react-redux';
import { BottomSheetActions } from '../../../Reducer/BottomSheetReducer';
import usePhoneCall from '../../../Hooks/useCallHandler';

export default function M_WOS_BASIC_03(props) {
  const { userInfo } = useSelector((state) => state.BaseInfo);
  const { navigate } = useAppNavigate();
  const { handleCall } = usePhoneCall();
  const ToggleDrawer = props.ToggleDrawer ?? (() => () => {});
  const dispatch = useDispatch();
  const bottomSheetState = useSelector((state) => state.bottomSheet);
  const isManager = userInfo.authCd !== 'EMPLOYEE';
  const isWorkerSelfRequest =
    props.workStopData?.createId === userInfo.decUserId;

  return (
    <Box
      sx={{
        height: '100%',
        px: 2,
        fontSize: 14,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        overflowY: 'hidden',
      }}
    >
      {/* 새로고침 버튼 */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end',
        }}
      >
        <button
          style={{
            all: 'unset',
            cursor: 'pointer',
            color: '#6DB753',
            display: 'flex',
            alignItems: 'center',
            gap: '4px',
          }}
          onClick={() => {
            props.SearchLogic1();
          }}
        >
          <Icon.Refresh width={24} height={24} />
          <p style={{ fontSize: '16px', fontWeight: 'bold' }}>새로고침</p>
        </button>
      </Box>

      {/* 내용 */}
      <Box sx={{ mb: '10rem' }}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Lottie
            animationData={SirenAnimation}
            loop
            autoplay
            style={{ width: 90 }}
          />
          <p style={{ fontSize: '36px', fontWeight: 'bold', color: '#EA4B4B' }}>
            작업 중지
          </p>
        </Box>
        <Box sx={{ px: 2, fontWeight: 'bold', fontSize: '16px' }}>
          <p style={{ fontSize: '20px' }}>작업이 일시 중지되었습니다.</p>
          {isManager ? (
            <>
              <Box sx={{ display: 'flex', gap: 1 }}>
                <p>1.</p>
                <p>
                  관리자는{' '}
                  <span style={{ color: '#F58A48' }}>
                    {' '}
                    작업 중지 내용을 확인하고
                  </span>{' '}
                  <br />
                  <span style={{ color: '#F58A48' }}>후속 조치를 선택</span>해
                  재개 승인을 진행해 주세요.
                </p>
              </Box>
              <Box sx={{ display: 'flex', gap: 1 }}>
                <p>2.</p>
                <p>
                  근로자는 승인이 날 때까지{' '}
                  <span style={{ color: '#F58A48' }}> 작업을 멈추고</span>{' '}
                  <br />
                  <span style={{ color: '#F58A48' }}>안전 지점에서 대기</span>해
                  주세요.
                </p>
              </Box>
              <Box sx={{ display: 'flex', gap: 1 }}>
                <p>3.</p>
                <p>
                  승인 후{' '}
                  <span style={{ color: '#F58A48' }}>
                    [작업 재개] 버튼으로 다시 시작
                  </span>
                  할 수 있습니다.
                </p>
              </Box>
            </>
          ) : isWorkerSelfRequest ? (
            <p style={{ lineHeight: 1.6, marginTop: '8px' }}>
              요청 주신 작업중지 건은 즉시 접수되었으며, 관리자가 현장 확인 및
              조치를 진행 중입니다.
              <br />
              위험요인을 제거할 때까지 비상대피 집결장소에서 대기해 주세요.
              안전이 확보되면 작업 재개 여부 등을 안내드리겠습니다.
            </p>
          ) : (
            <p style={{ lineHeight: 1.6, marginTop: '8px' }}>
              작업중지 지시를 받은 모든 근로자는 진행 중인 작업을 즉시 중단하고
              장비를 정지 바랍니다.
              <br />
              위험요인을 제거할 때까지 비상대피 집결장소에서 대기해 주세요.
              안전이 확보되면 작업 재개 여부 등을 안내드리겠습니다.
            </p>
          )}
        </Box>
        <button
          style={{
            all: 'unset',
            cursor: 'pointer',
            backgroundColor: '#E2E2E2',
            color: '#4A4747',
            padding: '4px 8px',
            borderRadius: '8px',
            fontWeight: 'bold',
            fontSize: '14px',
            margin: '8px 16px',
          }}
          onClick={() => {
            dispatch(
              BottomSheetActions.SetBottomSheetState({
                bottom: true,
                type: 'checkWorkStop',
              })
            );
          }}
        >
          작업 중지 내용 확인하기
        </button>
      </Box>
      {/* 하단 버튼 */}

      {!isManager && userInfo.posiNm !== '관리감독자' ? (
        <Box
          sx={{
            gap: 1,
            mb: 2,
            display: 'flex',
            justifyContent: 'center',
            width: '100%',
          }}
        >
          <Button
            name={
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 0.5,
                  width: '100%',
                  justifyContent: 'center',
                  fontWeight: 'bold',
                }}
              >
                <Icon.Emergency />
                비상연락
              </Box>
            }
            sx={{
              width: '100%',
              height: 36,
              borderRadius: '5px',
              backgroundColor: '#57B84D',
              color: '#fff',
              boxShadow:
                '0px 2px 3px -1px rgba(0,0,0,0.1), 0px 1px 0px 0px rgba(25,28,33,0.02), 0px 0px 0px 1px rgba(25,28,33,0.08)',
            }}
            onClick={(e) => {
              e.stopPropagation();
              navigate('/M_EmergencyTel');
            }}
          />
          <Button
            name={
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 0.5,
                  width: '100%',
                  justifyContent: 'center',
                  fontWeight: 'bold',
                }}
              >
                <Icon.Home />홈
              </Box>
            }
            sx={{
              width: '100%',
              height: 36,
              borderRadius: '5px',
              backgroundColor: '#4A90D9',
              color: '#fff',
              boxShadow:
                '0px 2px 3px -1px rgba(0,0,0,0.1), 0px 1px 0px 0px rgba(25,28,33,0.02), 0px 0px 0px 1px rgba(25,28,33,0.08)',
              '&:hover': {
                backgroundColor: '#357ABD',
              },
            }}
            onClick={(e) => {
              e.stopPropagation();
              navigate('/Home');
            }}
          />
        </Box>
      ) : (
        <PerButton
          saveText={'작업 재개'}
          cancelText={
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 0.5,
                width: '100%',
                justifyContent: 'center',
                fontWeight: 'bold',
                opacity:
                  userInfo.decUserId === props.workStopData?.createId ? 0.5 : 1,
              }}
            >
              <Icon.PhoneFill />
              전화걸기
            </Box>
          }
          onCancel={(e) => {
            e.stopPropagation();
            const isCreator =
              userInfo.decUserId === props.workStopData?.createId;
            if (!isCreator) {
              handleCall(props.workStopData?.tel);
            } else {
              dispatch(
                showSnackbar({
                  message: '자신이 작성한 건에는 전화할 수 없습니다.',
                  type: 'warning',
                })
              );
            }
          }}
          onClick={() => {
            navigate(
              `/M_WorkStop/detail/${props.workStopData?.workStopCd ?? props.workStopData?.workStopCd}`
            );
          }}
        />
      )}

      {bottomSheetState.bottom && bottomSheetState.type === 'checkWorkStop' && (
        <WorkStopDetailBottomSheet
          open={true}
          ToggleDrawer={ToggleDrawer}
          workStopData={props.workStopData}
          stopImageList={props.stopImageList}
          setStopImageList={props.setStopImageList}
        />
      )}
    </Box>
  );
}
